export const SET_PLANO = (state, payload) => {
  state.plano = payload;
};
export const SET_DADOS_INTERNOS = (state, payload) => {
  state.id_vendedor = payload.id_vendedor;
  state.id_produto = payload.id_produto;
  state.id_plano = payload.id_plano;
  state.id_unidade = payload.id_unidade;
  state.nome_unidade = payload.nome_unidade;
  state.nome_vendedor = payload.nome_vendedor;
  state.nome_produto = payload.nome_produto;
  state.nome_plano = payload.nome_plano;
};
